define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var BulkEditPhoneNumberModel = /** @class */ (function () {
        function BulkEditPhoneNumberModel(data) {
            this.CustomerName = ko.observable();
            this.CustomerId = ko.observable(0);
            this.Comment = ko.observable();
            this.CommentAppendType = ko.observable("InsertAfter");
            this.PhoneNumberProviderId = ko.observable();
            this.OfficeLocationId = ko.observable();
            this.PhoneNumberStatusId = ko.observable();
            this.PhoneNumberTypeId = ko.observable();
            this.BTN = ko.observable();
            this.EntityName = ko.observable();
            this.AllowSipToSip = ko.observable(2);
            this.CNam = ko.observable();
            this.SmsOnlyLoa = ko.observable();
            this.SmsEnabled = ko.observable();
            this.SmsProEnabled = ko.observable();
            this.CampaignId = ko.observable();
            this.BulkEditAllowSipToSip = ko.observable();
            this.BulkEditBrekeke = ko.observable();
            this.BulkEditCustomer = ko.observable();
            this.BulkEditE911 = ko.observable();
            this.BulkEditPhoneNumberProvider = ko.observable();
            this.BulkEditBTN = ko.observable();
            this.BulkEditCNam = ko.observable();
            this.BulkEditOfficeLocation = ko.observable();
            this.BulkEditPhoneNumberStatus = ko.observable();
            this.BulkEditPhoneNumberType = ko.observable();
            this.BulkEditSmsOnlyLoa = ko.observable();
            this.BulkEditSmsEnabled = ko.observable();
            this.BulkEditSmsProEnabled = ko.observable();
            this.BulkEditCampaignId = ko.observable();
            this.Numbers = ko.observableArray();
            this.NumbersIds = ko.observableArray();
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, BulkEditPhoneNumberModel.Mapping, self);
            }
        }
        BulkEditPhoneNumberModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new BulkEditPhoneNumberModel(options.data);
            }
        };
        return BulkEditPhoneNumberModel;
    }());
    return BulkEditPhoneNumberModel;
});
//# sourceMappingURL=BulkEditPhoneNumberModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/BulkEditPhoneNumberModel.js
// module id = 193
// module chunks = 2